import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, take, switchMap, of } from 'rxjs';

const REQUIRED_ROLE = 'Developers.Edit';

export const authGuard: CanActivateFn = () => {
  const authService      = inject(MsalService);
  const broadcastService = inject(MsalBroadcastService);
  const router           = inject(Router);

  // Wait until MSAL has finished processing any redirect/interaction
  // before reading accounts — prevents the race condition where
  // getAllAccounts() returns [] during the redirect callback
  return broadcastService.inProgress$.pipe(
    filter(status => status === InteractionStatus.None),
    take(1),
    switchMap(() => {
      const accounts = authService.instance.getAllAccounts();

      // Not authenticated — let MsalGuard handle the SSO redirect
      if (accounts.length === 0) {
        return of(true);
      }

      // Authenticated — enforce the required app role
      const roles = (accounts[0].idTokenClaims as { roles?: string[] })?.roles ?? [];
      if (roles.includes(REQUIRED_ROLE)) {
        return of(true);
      }
      router.navigate(['/unauthorized']);
      return of(false);
    })
  );
};
